import { render, staticRenderFns } from "./createDispenseRequest.vue?vue&type=template&id=420477fa&"
import script from "./createDispenseRequest.vue?vue&type=script&lang=js&"
export * from "./createDispenseRequest.vue?vue&type=script&lang=js&"
import style0 from "./createDispenseRequest.vue?vue&type=style&index=0&id=420477fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports